module.exports = __webpack_public_path__ + "img/bluecross.f2deaa5b.png";